document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('TeamModal');
    const modalContent = document.getElementById('TeamModalContent');
    const triggers = document.querySelectorAll('.team-card__trigger');

    if (!modal || !modalContent || !triggers.length) return;

    let scrollPos = 0;

    triggers.forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();

            const card = this.closest('.team-card');
            const source = card.querySelector('.team-card__modal-source');

            if (!source) return;

            // Copy content from hidden source to modal shell
            modalContent.innerHTML = source.innerHTML;

            // --- Robust Scroll Lock (No-Jump Fixed Method) ---
            scrollPos = window.scrollY || window.pageYOffset;

            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollPos}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';

            // Show the dialog
            modal.showModal();

            // GSAP Animation
            if (typeof gsap !== 'undefined') {
                gsap.fromTo(modal,
                    { opacity: 0 },
                    { opacity: 1, duration: 0.3, ease: "power2.out" }
                );

                const contentInner = modalContent.querySelector('.team-card__dialog-content');
                if (contentInner) {
                    gsap.fromTo(contentInner,
                        { y: 30, opacity: 0 },
                        { y: 0, opacity: 1, duration: 0.5, delay: 0.1, ease: "power2.out" }
                    );
                }
            }
        });
    });

    const closeDialog = () => {
        const cleanupAndRestore = () => {
            modal.close();

            // 1. Release the fixed body
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // 2. Force the browser to calculate the full document height synchronously
            void document.body.offsetHeight;

            // 3. IMMEDIATELY restore scroll position before the browser paints the next frame.
            // Using { behavior: 'instant' } overrides any global smooth scrolling CSS
            // that might try to animate this jump.
            window.scrollTo({
                top: scrollPos,
                left: 0,
                behavior: 'instant'
            });

            modalContent.innerHTML = ''; // Clear content

        };

        if (typeof gsap !== 'undefined') {
            gsap.to(modal, {
                opacity: 0,
                duration: 0.2,
                ease: "power2.in",
                onComplete: cleanupAndRestore
            });
        } else {
            cleanupAndRestore();
        }
    };

    // --- EVENT DELEGATION FOR CLOSE BUTTONS ---
    // This handles both the static close button in team.liquid AND any 
    // close buttons injected from team-card.liquid dynamically.
    modal.addEventListener('click', function (e) {
        // Check if the clicked element (or its parents) is a close button
        if (e.target.closest('.team-card__dialog-close')) {
            e.preventDefault();
            closeDialog();
            return;
        }

        // --- Handle Backdrop Click ---
        // Only close if the click was directly on the modal element (the backdrop)
        // and NOT on the inner content container.
        const rect = modalContent.getBoundingClientRect();
        const isInContent = (
            rect.top <= e.clientY &&
            e.clientY <= rect.top + rect.height &&
            rect.left <= e.clientX &&
            e.clientX <= rect.left + rect.width
        );

        if (!isInContent) {
            closeDialog();
        }
    });

    // Handle Escape key
    modal.addEventListener('cancel', (e) => {
        e.preventDefault();
        closeDialog();
    });
});
